import React from 'react';
import Link from 'gatsby-link';
import Slider from 'react-slick';

import './_header.scss';
import HeaderButton from './button';

const settings = {
  dots: true,
  infinite: true,

  autoplay: true,
  autoplaySpeed: 4000,
  speed: 500,
  pauseOnHover: true,
  
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const Header = () =>
  (<header className="header">
    <div className="container content">
      <h1 className="massive featured attention">
      Maximale Früherkennung durch Radiodiagnostik
      </h1>
      <Link to="/contact" className="button">
        Vorsorgetermin vereinbaren
      </Link>
    </div>
    <div className="container centered">
      <div className="grid-desktop">
        <HeaderButton text="Wie erhalte ich einen Termin als Privatpatient?" link="/faq?privatpatient"/>
        <HeaderButton text="Was gilt es bei einer Schwanger&shy;schaft zu beachten?" link="/faq?schwangerschaft"/>
        <HeaderButton text="Was sind Kontrastmittel?" link="/faq?kontrastmittel"/>
        <HeaderButton text="Was ist, wenn ich stille?" link="/faq?stillen"/>
        <HeaderButton text="In welchen zeitlichen Abständen kann ich eine Mammographie in Anspruch nehmen?" link="/faq?mammographie"/>
        <HeaderButton text="Wer teilt mir meine Untersuchungsergebnisse mit?" link="/faq?ergebnisse"/>
      </div>
      <div className="grid-mobile">
        <Slider {...settings}>
          <div className="grid">
            <HeaderButton text="Wie erhalte ich einen Termin als Privatpatient?" link="/faq?privatpatient"/>
            <HeaderButton text="Was gilt es bei einer Schwanger&shy;schaft zu beachten?" link="/faq?schwangerschaft"/>
          </div>
          <div className="grid">
            <HeaderButton text="Was sind Kontrastmittel?" link="/faq?kontrastmittel"/>
            <HeaderButton text="Was ist, wenn ich stille?" link="/faq?stillen"/>
          </div>
          <div className="grid">
            <HeaderButton text="In welchen zeitlichen Abständen kann ich eine Mammographie in Anspruch nehmen?" link="/faq?mammographie"/>
            <HeaderButton text="Wer teilt mir meine Untersuchungsergebnisse mit?" link="/faq?ergebnisse"/>
          </div>
          </Slider>
      </div>
      <Link to="/faq" className="centered">
        Alle Fragen und Antworten anzeigen
      </Link>
    </div>
    <hr/>
    <div className="container centered">
      <div className="contact">
        <p className="smaller">
          Sie haben Fragen? Wir freuen uns über Ihren Anruf:<br/>
          Unsere Email-Adresse: <a className="smaller" href="mailto:office@radbregenz.at">office@radbregenz.at</a>
        </p>
        <a href="tel:0043557453500" className="huge plain lining-nums">+43 5574 53500</a>
      </div>
    </div>
  </header>);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.jsx